export interface AppConfigurationsResponse {
  ordergrooveEnabled: boolean
}

export const fetchAppConfigurationsApi = () => {
  return useNuxtApp().$siteFetch<AppConfigurationsResponse>('/app/configurations')
}
